import * as React from 'react'
import { makeStyles, ButtonBase, Tooltip } from '@material-ui/core';
import theme from '../../theme';
import { CommonTableTwo } from '../table';
import CommonButton from '../button';
import CommonDatePicker from '../datepicker';
import EndDatePicker from '../datepicker/endDatePicker';
import { useSelector, useDispatch } from 'react-redux';
import { sendMonthlyCompanyReportsAction } from '../../containers/dashboard/action';
import { moneyValue, getStartEndDate } from '../../utils';
import CustomNotificationReports from './cutomNotificationReports';
import {ThreeDotsLoading} from '../loading';
import DragDatePreviewer from '../datepicker/dragDatePickerPreviewer';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 175px)",
    padding: "45px 90px",
    marginLeft: "220px",
    maxWidth: "70%",
    height: "100%"
  },
  table: {},
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "& .title": {
      color: theme.colors.Violet,
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "24px",
    },
  },
  titleContainer: {
    borderRadius: "10px",
    padding: "8px",
    maxWidth: "50%",
    marginRight: "10px",
    "&:hover": {
      backgroundColor: theme.colors.Gallery,
      cursor: "pointer"
    },
    "&.selected": {
      backgroundColor: theme.colors.Gallery,
    }
  },
  headerTwoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .title": {
      color: theme.colors.Violet,
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "16px",
      padding: "20px",
      cursor: "pointer",
    },
  },
  headerName: {
    fontSize: "13px",
    fontFamily: theme.fontFamily.MARKPROHEAVY,
    opacity: "0.3",
    color: theme.colors.Violet,
  },
  body: {
    backgroundColor: theme.colors.White,
    padding: "12px",
    boxShadow: " 20px 20px 60px #e6e6e6,-20px -20px 60px #ffffff",
  }
}))

export default function NotificationsReports() {
  const classes = useStyles();

  const dispatch = useDispatch()
  const dashboardReducer = useSelector(state => state.dashboardReducer)
  const loginReducer = useSelector(state => state.loginReducer)


  const [start_date, end_date] = getStartEndDate()
  const [startDate, setStartDate] = React.useState(start_date.toISOString())
  const [endDate, setEndDate] = React.useState(end_date.toISOString())
  const [sendPaymentUrlLink, setSendPaymentUrlLink] = React.useState(false)
  const [currentTab, setCurrentTab] = React.useState("Send Reports")

  const sendMonthlyCompanyReportsActionMethod = React.useCallback(
    data => {
      dispatch(sendMonthlyCompanyReportsAction(data))
    }, [endDate, startDate, dispatch]
  )

  return (<div className={classes.root}>
    <ThreeDotsLoading showLoader={dashboardReducer?.loading || loginReducer.loading} />
    {dashboardReducer?.error?.length ? (
      <div className={"error-container"}>
        {Array.isArray(dashboardReducer.error) &&
          dashboardReducer.error.map((each, index) => (
            <div key={index}>{each}</div>
          ))}
      </div>
    ) : null}
    {dashboardReducer?.companyMonthlyReportsError?.length ? (
      <div className={"error-container"}>
        {Array.isArray(dashboardReducer.companyMonthlyReportsError) &&
          dashboardReducer.companyMonthlyReportsError.map((each, index) => (
            <div key={index}>{each}</div>
          ))}
      </div>
    ) : null}
    {dashboardReducer?.companyCustomReportsError?.length ? (
      <div className={"error-container"}>
        {Array.isArray(dashboardReducer.companyMonthlyReportsError) &&
          dashboardReducer.companyMonthlyReportsError.map((each, index) => (
            <div key={index}>{each}</div>
          ))}
      </div>
    ) : null}
    <div className={classes.body}>
      <div className={classes.headerContainer}>
        <ButtonBase
          className={`${classes.titleContainer} ${currentTab === 'Send Reports' ? 'selected' : ''}`}
          onClick={(e) => {
            setCurrentTab(e.target.innerText)
          }}
        >
          <header className='title'
          >
            Send Reports
          </header>
        </ButtonBase>
        <ButtonBase
          className={`${classes.titleContainer} ${currentTab === 'Custom Companies' ? 'selected' : ''}`}
          onClick={(e) => {
            setCurrentTab(e.target.innerText)
          }}
        >
          <header
            className='title'
          >
            Custom Companies
          </header>
        </ButtonBase>
      </div>
      <div className={classes.table}>
        {
          currentTab === "Send Reports" ? (
            <>
              <div
                style={
                  {
                    color: theme.colors.DodgerBlue,
                    fontFamily: theme.fontFamily.MARKPROBOLD,
                    fontWeight: 'bolder'
                  }
                }
              >
                Click To Include Checkout Link
                <Tooltip arrow title='Select To Include Paystack Link'>
                  <input
                    type="checkbox"
                    checked={sendPaymentUrlLink}
                    onChange={() => {
                      setSendPaymentUrlLink(s => !s)
                    }}
                  />
                </Tooltip>
              </div>
              <CommonTableTwo
                columns={
                  [
                    {
                      Header: "Calendar Picker",
                      accessor: "start_datetime",
                      Cell: (data, row) => {
                        return (<div>
                          <DragDatePreviewer
                            startDateValue={startDate?.split("T")[0]}
                            setStartDateValue={(date) => {
                              const dt = new Date(date)
                              setStartDate(dt.toISOString())
                            }}
                            endDateValue={endDate?.split("T")[0]}
                            setEndDateValue={(date) => {
                              const dt = new Date(date)
                              setEndDate(dt.toISOString())
                            }}
                            absoluteCalendar={false}
                          />
                        </div>)
                      }
                    },

                    {
                      Header: "Triggers",
                      accessor: "trigger_word",
                      Cell: (data, row) => {
                        return (
                          <CommonButton onClick={
                            (e) => {
                              sendMonthlyCompanyReportsActionMethod({
                                start_date: startDate,
                                end_date: endDate,
                                send_url_link: sendPaymentUrlLink
                              })
                            }} text={data} stylevariant="primary"
                          />
                        )
                      }
                    }
                  ]
                }
                data={[
                  {
                    "start_datetime": startDate,
                    "end_datetime": endDate,
                    "trigger_word": "Send Reports"
                  }
                ]}
              />

              <CommonTableTwo
                columns={
                  [
                    {
                      Header: "Start Datetime",
                      accessor: "start_datetime",
                      Cell: (data, row) => {
                        return (<div>
                          <CommonDatePicker
                            setStartDate={(date) => {
                              setStartDate(new Date(date).toISOString());
                            }}
                            startDate={data?.split("T")[0]}
                          /></div>)
                      }
                    },
                    {
                      Header: "End Datetime",
                      accessor: "end_datetime",
                      Cell: (data, row) => {
                        return (
                          <div>
                            <EndDatePicker
                              setEndDate={
                                (date) => {
                                  setEndDate(new Date(date).toISOString())
                                }
                              }
                              endDate={data?.split("T")[0]}
                            />
                          </div>
                        )
                      }
                    },
                    {
                      Header: "Triggers",
                      accessor: "trigger_word",
                      Cell: (data, row) => {
                        return (
                          <CommonButton onClick={
                            (e) => {
                              sendMonthlyCompanyReportsActionMethod({
                                start_date: startDate,
                                end_date: endDate,
                                send_url_link: sendPaymentUrlLink
                              })
                            }} text={data} stylevariant="primary"
                          />
                        )
                      }
                    }
                  ]
                }
                data={[
                  {
                    "start_datetime": startDate,
                    "end_datetime": endDate,
                    "trigger_word": "Send Reports"
                  }
                ]}
              />
              {
                dashboardReducer?.companyMonthlyReportsSuccess?.data ? (
                  <div className={classes.body}>
                    <div className={classes.headerTwoContainer}>
                      <header className='title'>Summary</header>
                    </div>
                    <div>
                      <CommonTableTwo
                        columns={[
                          {
                            Header: "Grand Total",
                            accessor: "summary",
                            Cell: (data, row) => {
                              return (<div>{moneyValue(data?.grand_total)}</div>)
                            }

                          },
                          {
                            Header: "Total Fees",
                            accessor: "summary",
                            Cell: (data, row) => {
                              return (<div>{moneyValue(data?.total_fees)}</div>)
                            }
                          }, {
                            Header: "Date Ending",
                            accessor: "summary",
                            Cell: (data, row) => {
                              return (<div>{(new Date(data?.date_ending)).toLocaleDateString()}</div>)
                            }
                          }
                        ]}
                        data={
                          dashboardReducer?.companyMonthlyReportsSuccess?.data ? [
                            dashboardReducer?.companyMonthlyReportsSuccess?.data
                          ] : null
                        }
                      />
                    </div>

                  </div>
                ) : null
              }
            </>
          ) : (
            <>
              {
                currentTab === "Custom Companies" ? (
                  <CustomNotificationReports />
                ) : null
              }
            </>
          )
        }

      </div>
    </div>
  </div>)
}